
import { errorStore } from '@/store'
import { ErrorUtils } from '@/commons/utils/error'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ErrorMessageKeys } from '@/commons/constants/application'

@Component({
    computed: {
        ErrorMessageKeys () {
            return ErrorMessageKeys
        }
    }
})
export default class ModalBoxErrorContent extends Vue {
    @Prop() closeCallback!: () => void

    get errorMessageKeys (): Array<string> {
        return errorStore.getMessageTranslationKeys
    }

    get errorCode (): string {
        return errorStore.getErrorCode || ''
    }

    get isCloseButtonDisabled (): boolean {
        return typeof this.closeCallback !== 'function'
    }

    closeModal (): void {
        if (typeof this.closeCallback === 'function') {
            this.closeCallback()
        }
    }

    isMessageWithUrl (key: string): boolean {
        return ErrorUtils.isUrlInErrorMessage(key)
    }

    isMessageWithUrlAtEnd (key: string): boolean {
        return ErrorUtils.isUrlAtEndOfErrorMessage(key)
    }

    isMessageWithUrlInMiddle (key: string): boolean {
        return ErrorUtils.isUrlInMiddleOfErrorMessage(key)
    }

    getMessageUrl (key: string): string {
        return ErrorUtils.getErrorMessageUrl(key)
    }
}
